import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyClipboard from 'vuetify-clipboard-input';

Vue.config.productionTip = false


const firebaseConfig = {
    apiKey: "AIzaSyD1I8j40DUQOHJdUdjLOSKMr1dQwgK0dE4",
    authDomain: "nhl-manager.firebaseapp.com",
    databaseURL: "https://nhl-manager.firebaseio.com",
    projectId: "nhl-manager",
    storageBucket: "nhl-manager.appspot.com",
    messagingSenderId: "109186461928",
    appId: "1:109186461928:web:a5669fe5a75444ff"
};

Vue.use(VuetifyClipboard);
Vue.use(Vuetify);


firebase.initializeApp(firebaseConfig)

firebase.auth().onAuthStateChanged(user => {
    store.commit('updateUser', {user})
});



new Vue({
    vuetify: new Vuetify(),
    router: router,
    render: h => h(App)
}).$mount('#app');
